import { mapState, mapActions } from 'vuex';
import EisCodeForm from '../EisCodeForm/EisCodeForm.vue';

export default {
  components: { EisCodeForm },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions(['getApplicationStatus']),
    eisCodeSubmit(eisCode) {
      this.getApplicationStatus({ eisCode })
        .then(() => {
          
        })
        .catch(() => {
          console.log('err');
          this.$notify.error({
            title: 'Помилка!',
            message: 'Заявка відсутня в системі.',
          });
        });
    },
  },
  computed: {
    ...mapState({
      applicationStatus: (state) => state.Applications.application.status,
      eisCode: (state) => state.Applications.application.eisCode,
    }),
  },
  beforeMount() {
    if (this.eisCode) {
      this.getApplicationStatus();
    }
  },
};
